import React from "react";
import { Col, Button, Modal, Row } from "react-bootstrap";
export const InitialDeclinePageModal = ({
  isOpen,
  onHide,
  nextButton,
  selectReason,
  reason,
  
}) => {
  let DelineOptionArray = [
    "I am unavailable on the day or time (10am Mon 14 May) ",
    `I have a little or no knowledge of the topics or subject are 
      requested`,
    "I want a different rate, lesson duration, start time or day",
    "I am uncomfortable with this lesson request",
  ];
  return (
    <div>
      <Modal
        size="lg"
        className="ProfileStatus-modal decline-modal"
        show={isOpen}
        onHide={onHide}
      >
        <Modal.Body>
          <Row>
            <Col
              lg={12}
              md={12}
              sm={12}
              xs={12}
              style={{ padding: "10px 40px", textAlign: "justify" }}
            >
              <div
                className="cancel-btn flex-center-center"
                onClick={onHide}
                style={{
                  fontSize: "17px",
                  width: "30px",
                  height: "30px",
                  marginTop: "20px",
                }}
              >
                <i className="mdi mdi-close"></i>
              </div>
              <div style={{ marginBottom: "50px" }} />
              <h3>Accept Mawuli for weekly lessons ? </h3>
              <div className="modal-para"style={{ marginBottom: "15px" }} >
                They would like to book weekly Maths (GCSE) to take place at the
                online classroom starting on Mon 14 May from 9:00AM - 10:00AM.
                Your earning for each lesson is £16.00
              </div>
              <div className="flex" style={{ flexDirection: "column" }}>
                {DelineOptionArray.length
                  ? DelineOptionArray.map((question, i) => (
                      <div className="custom-control custom-radio custom-control-inline radio-decline-status">
                        <input
                          type="radio"
                          id={`customRadioInline${i}`}
                          name={`customRadioInline0`}
                          className="custom-control-input"
                          checked={reason === i}
                        />
                        <label
                          className="custom-control-label common-para"
                          htmlFor={`customRadioInline${i}`}
                          onClick={() => selectReason(question, i)}
                          style={{ color: "#1c1c1c" }}
                        >
                          {question}
                        </label>
                      </div>
                    ))
                  : "no data"}
              </div>
              <div className="flex-end-center" style={{ marginTop: "30px" }}>
                <Button
                  className="green-Button"
                  style={{
                    width: "126px",
                    height: "45px",
                    backgroundColor: "#2cb46d",
                    fontFamily: "CircularStdMedium, Arial, sans-serif",
                    fontSize: "16px",
                    fontWeight: "normal",
                    fontStretch: "normal",
                    fontStyle: "normal",
                    color: "#ffffff",
                  }}
                  onClick={nextButton}
                >
                  Next
                </Button>
              </div>
            </Col>
          </Row>
        </Modal.Body>
      </Modal>
    </div>
  );
};
